module.exports = __webpack_public_path__ + "static/media/two-modes.b6f6388.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/afc/two-modes.mp3
// module id = Y4Xp
// module chunks = 0